import { Button } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import Heading from "../Heading/Heading";

import style from "./NonEduEmailWarning.module.css";

interface NonEduEmailWarningProps {
  dismissWarning: () => void;
}

const NonEduEmailWarning: React.FC<NonEduEmailWarningProps> = ({ dismissWarning }) => {
  const { goToProfile } = useNavigation();
  return (
    <section>
      <div className={style.container}>
        <Heading type="h1" className={style.title}>
          We can&apos;t recognize this EDU email address
        </Heading>
        <p>
          Please double check if you&apos;ve entered your EDU email address correctly. If this is
          your actual EDU email address, you may continue.
        </p>
        <div className={style.buttonContainer}>
          <Button onClick={() => goToProfile()}>Change my email</Button>
          <Button variant="grayscale" onClick={dismissWarning}>
            Continue anyways
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NonEduEmailWarning;
